module.exports = __webpack_public_path__ + "static/media/m7.db3f3652.jpg";